<div class="flex items-center gap-4 rounded-lg cursor-pointer">
    <img class="w-10 h-10 rounded-full object-cover object-center flex-shrink-0" src="{{ imageSrc }}" alt="{{ username }}">
    <div class="font-medium dark:text-white">
        <div>{{ username }}</div>
        <div class="text-sm text-gray-500 dark:text-gray-400">{{ subtitle }}</div>
    </div>
</div>